var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7169 6.07197C22.9267 6.56147 22.7 7.12835 22.2105 7.33814L17.3192 9.4344C16.8297 9.64419 16.2628 9.41743 16.053 8.92793C15.8432 8.43844 16.07 7.87156 16.5595 7.66177L21.4508 5.56551C21.9403 5.35572 22.5071 5.58247 22.7169 6.07197Z",
    fill: "#878B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6507 12.8435C20.474 13.3459 19.9235 13.61 19.4211 13.4333L17.6743 12.8191C17.1719 12.6424 16.9079 12.0919 17.0845 11.5895C17.2612 11.0871 17.8117 10.8231 18.3141 10.9997L20.0609 11.6139C20.5633 11.7906 20.8273 12.3411 20.6507 12.8435Z",
    fill: "#878B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6889 6.19114C15.1431 6.46921 15.7368 6.32644 16.0148 5.87225L17.063 4.16031C17.341 3.70611 17.1983 3.11249 16.7441 2.83441C16.2899 2.55634 15.6963 2.69911 15.4182 3.1533L14.3701 4.86524C14.092 5.31944 14.2348 5.91306 14.6889 6.19114Z",
    fill: "#878B92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2696 3.39612C10.6208 3.43113 10.9248 3.65524 11.0622 3.98038L16.0807 15.8592C16.2126 16.1713 16.171 16.5297 15.9711 16.8033C15.7713 17.0768 15.4426 17.2255 15.1052 17.1948L7.41887 16.496C7.08629 16.4658 6.79303 16.2657 6.64369 15.967L4.54742 11.7744C4.39107 11.4617 4.41623 11.0889 4.61318 10.8L9.3772 3.81245C9.57603 3.52082 9.91832 3.36112 10.2696 3.39612ZM9.97412 6.3605L6.52565 11.4185L8.12842 14.624L13.6784 15.1286L9.97412 6.3605Z",
    fill: "#878B92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18364 11.8782C2.65998 11.6401 3.2392 11.8331 3.47736 12.3095L6.97114 19.297C7.2093 19.7734 7.01623 20.3526 6.5399 20.5907C6.06356 20.8289 5.48435 20.6358 5.24618 20.1595L1.7524 13.1719C1.51424 12.6956 1.70731 12.1164 2.18364 11.8782Z",
    fill: "#878B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.25a26f25581e4da26cc0f30343e85228.svg";
export { ForwardRef as ReactComponent };